import { render } from "./MultiRevokeSignOffModal.vue?vue&type=template&id=42283552&scoped=true"
import script from "./MultiRevokeSignOffModal.vue?vue&type=script&lang=js"
export * from "./MultiRevokeSignOffModal.vue?vue&type=script&lang=js"

import "./MultiRevokeSignOffModal.vue?vue&type=style&index=0&id=42283552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42283552"]])

export default __exports__